import React from "react";
import HomeView from "../homeView/HomeView";
import {Col, Row} from "reactstrap";
import TeacherTile from "../../../../../components/TeacherTile/App";
import * as commonFunc from "../../../../../utils/commonFunc";
import webConfig from "../../../../../config/WebConfig";
import * as instituteService from "../../../../../services/institute";
import * as actionSpinnerCreator from "../../../../../store/domain/spinner/action";
import * as actionInstituteCreator from "../../../../../store/domain/institute/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import Header from "../../../../../components/Header/Header";
import CardsFooter from "../../../../../components/Modals/Footers/CardsFooter";
import './allteachers.scss'
class AllTeachersView extends React.Component {

    state = {
        teacher: [],
        screenSize: 1440,
    };

    componentDidMount() {
        let colorType = commonFunc.lightOrDark(webConfig.primaryColor);
        this.setState({screenSize: window.innerWidth});
        if (webConfig.LMSStatus === "LMS") {
            this.fetchInstituteTeachers();
        } else {
            this.props.fetchTeachers(webConfig.teachersDetails)
        }
    }

    fetchInstituteTeachers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        await instituteService.getInstituteTeachers()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.props.fetchTeachers(response.body.teachers);
                    this.setState({teachers: response.body.teachers})
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };

    render() {
        let {teachers} = this.props;
        let {screenSize} = this.state;
        return (
            <div>
                <Header active={0}/>
                <main>
                    <HomeView/>

                    <div className="allTeachers container">

                        <Row className='teachers-wrapper'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <div className="teacher-topic-holder">
                                    <h1 className={'main-topic'}>
                                        Meet Our Teachers!
                                    </h1>
                                    <p className={' py-4'}>Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Autem deleniti,
                                        deserunt enim et exercitationem expedita molestiae praesentium sint vel
                                        voluptate? Deserunt exercitationem ipsum itaque molestiae nulla quae quo
                                        repellendus saepe?im et exercitationem expedita molestiae praesentium sint
                                        vel</p>
                                </div>
                            </Col>
                        </Row>

                        <Row className='my-4 justify-content-center'>
                            {teachers.map((teacher, index) =>
                           <TeacherTile key={index} teacher={teacher}/>)}
                        </Row>
                    </div>
                </main>
                <CardsFooter/>
            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    institute: state.institute.institute,
    teachers: state.institute.teachers,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchTeachers: data => dispatch(actionInstituteCreator.fetchTeachers(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllTeachersView));
